<template>
  <div class="tabs-common">
    <p class="common-title">Applicant’s Endorsement</p>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Date</label> -->
      <div class="col-sm-10">
        <NewDatepickerWrapper
          v-model="tab_data.endorsm_date"
          type="date"
          placeholder="Date">
        </NewDatepickerWrapper>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Name of Applicant's Representative</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.app_repr_name" placeholder="Name of Applicant's Representative">
        <label>Name of Applicant's Representative</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Applicant Name</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.app_name" placeholder="Applicant Name">
        <label>Applicant Name</label>
      </div>
    </div>
    <p class="common-title">Authorised Dealer’s Endorsement</p>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Date</label> -->
      <div class="col-sm-10">
        <NewDatepickerWrapper
          v-model="tab_data.adb_endors_date"
          type="date"
          placeholder="Date">
        </NewDatepickerWrapper>
        <!-- <input type="text" class="form-control" v-model="tab_data.adb_endors_date"> -->
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Name of Applicant's Representative</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.adb_name" placeholder="Name of Applicant's Representative">
        <label>Name of Applicant's Representative</label>
      </div>
    </div>
    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('Attachment',5)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Support Information',7)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewDatepickerWrapper from './../../fields/NewDatepickerWrapper.vue'
export default {
  name: 'tabs-endorsement',
  components: {NewDatepickerWrapper},
  props: ['cur_tab_name', 'indata'],
  mixins: [common],
  data() {
    return {
      tab_data: {
        adb_endors_date: '',
        app_name: '',
        endorsm_date: '',// TIMESTAMP(0) WITH TIME ZONE,
        app_repr_name: '',// VARCHAR(100),
        adb_name: '',
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
